export default {
  stockists: [],
}
